'use client';
import { getUserPromotions } from '#pplx/frontend/apps/ask/queries/billing-queries/promotions/getUserPromotions.js';
import { getUserPromotionsQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/userKeys.js';
import { STUDENT_PRO_PRICE_USD } from '#pplx/frontend/apps/ask/subscription/components/tierMetadata.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useMemo } from 'react';
export const useUserPromotionsQuery = ({ reason, }) => {
    const { data, isLoading } = useQuery({
        queryKey: getUserPromotionsQueryKey(),
        queryFn: () => getUserPromotions({ reason }),
    });
    const showStudentDiscountContent = !!data?.institution;
    let discountPrice = data?.offer?.discount_str ?? undefined;
    if (!discountPrice && showStudentDiscountContent) {
        discountPrice = `$${STUDENT_PRO_PRICE_USD.monthly}`;
    }
    const discountType = data?.offer?.discount_type ?? undefined;
    return useMemo(() => ({
        userPromotionsLoading: isLoading,
        discountPrice,
        discountType,
        showStudentDiscountContent,
        campaignId: data?.campaign?.id,
        institution: data?.institution,
    }), [
        data?.campaign?.id,
        data?.institution,
        discountPrice,
        discountType,
        isLoading,
        showStudentDiscountContent,
    ]);
};
//# sourceMappingURL=useUserPromotionsQuery.js.map